import React from 'react';
import dynamic from 'next/dynamic';
import { RoomRequestsProps } from './RoomRequests.types';

const DynamicRoomRequests = dynamic<RoomRequestsProps>(() =>
  import('./RoomRequests').then(module => module.RoomRequests)
);

export const RoomRequests: React.FC<RoomRequestsProps> = props => {
  const { nrpFeatureFlag } = props;

  if (nrpFeatureFlag) {
    return null;
  }

  return <DynamicRoomRequests {...props} />;
};
